import React from 'react';
import './chartist.min.css';
import AngleChart from '../results/angle-chart/angle-chart';
import './supination-pronation-section.css';
import AngleOverTimeChart from './angle_over_time_chart';

class PlayerSupinationPronationSection extends React.Component {
  render() {
    const angleData = this.props.angle_data;

    const leftData = angleData[0];
    const rightData = angleData[1];
    const anglesOverTimeData = angleData[2];

    const leftAVGData = {
      hand: 0,
      max_angle_left: leftData.pronation_avg,
      max_angle_right: leftData.supination_avg,
    };

    const leftMAXData = {
      hand: 0,
      max_angle_left: leftData.pronation_max,
      max_angle_right: leftData.supination_max,
    };

    const rightAVGData = {
      hand: 1,
      max_angle_left: rightData.supination_avg,
      max_angle_right: rightData.pronation_avg,
    };

    const rightMAXData = {
      hand: 1,
      max_angle_left: rightData.supination_max,
      max_angle_right: rightData.pronation_max,
    };

    return (
      <div className="mp-0 container-fluid card shadow supination_pronation_summary_container">
        <div className="supination_pronation_summary_section">
          <div className="supination_pronation_section_title">Supination Pronation Summary</div>
          <div className="supination_pronation_section_hand left">
            <div className="supination_pronation_section_hand_title">Left Hand</div>
            <AngleOverTimeChart angles_over_time_data={anglesOverTimeData.left} />
            <div className="angle_chart_container_inline">
              <div className="supination_pronation_section_chart_title">Avg. Angle</div>
              <AngleChart result={leftAVGData} show_text={false} dynamic={false} />
            </div>
            <div className="angle_chart_container_inline">
              <div className="supination_pronation_section_chart_title">Max Angle</div>
              <AngleChart result={leftMAXData} show_text={false} dynamic={false} />
            </div>
          </div>
          <div className="supination_pronation_section_hand right">
            <div className="supination_pronation_section_hand_title">Right Hand</div>
            <AngleOverTimeChart angles_over_time_data={anglesOverTimeData.right} />
            <div className="angle_chart_container_inline">
              <div className="supination_pronation_section_chart_title">Avg. Angle</div>
              <AngleChart result={rightAVGData} show_text={false} dynamic={false} />
            </div>
            <div className="angle_chart_container_inline">
              <div className="supination_pronation_section_chart_title">Max Angle</div>
              <AngleChart result={rightMAXData} show_text={false} dynamic={false} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PlayerSupinationPronationSection;
